(function ($) {
  'use strict';

  window.ys.TitanDesert = new TitanDesert();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('page-template-skoda-titan-desert')) {
    window.ys.TitanDesertContest = new TitanDesert.Contest();
  }
}).bind(window)(jQuery);
